import { cleanImportState } from 'actions/import';
import { fetchIntegrationSettings } from 'actions/integrationSettings';
import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getImportPageState } from 'selectors/import';
import { useSelector } from 'store';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import { useHistory } from 'utils/urls';
import EditIntegrationSettings from './EditIntegrationSettings';
import ImportDetails from './ImportDetails';
import ImportHeader from './ImportHeader';
import ImportReviewSelections from './ImportReviewSelections';

const CustomerImport: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const pageState = useSelector(getImportPageState);

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  const unblock = history.block((nav) => {
    const destinationPath = nav.pathname;

    if (!destinationPath.includes('permissions')) {
      dispatch(cleanImportState());
    }

    unblock();
  });

  useEffect(() => {
    dispatch(fetchIntegrationSettings());
  }, [dispatch]);

  const renderContent = (): JSX.Element => {
    switch (pageState) {
      case 1:
        return <ImportDetails />;
      case 2:
        return <ImportReviewSelections />;
      case 3:
        return <EditIntegrationSettings />;
      default:
        return <></>;
    }
  };

  return (
    <div
      className="min-w-screen bg-white"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />
      <div
        className="flex flex-row"
        style={{
          height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <SettingSidebar />
        <div className="pl-12 pr-12 pt-8 pb-6 flex flex-col w-full h-full overflow-auto">
          <header className="flex">
            <ImportHeader pageState={pageState} />
          </header>
          <main className="flex-1 flex flex-row w-full ">{renderContent()}</main>
        </div>
      </div>
    </div>
  );
};

export default CustomerImport;
